import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';

import Pages from 'configs/pages';
import {Session} from 'redux/actions';

const useSession = () => {
	const history = useHistory();
	const {idSession} = useParams();
	const dispatch = useDispatch();
	const sessionData = useSelector((state) => state.session);

	const getSession = () => {
		dispatch(Session.get(idSession));
	}

	const launchMethod = (method, params) => {
		if (typeof Session[method] === 'function') {
			dispatch(Session[method].apply(useSession, params));
		}
	}

	const updateSetup = (setup, callback) => {
		dispatch(Session.updateSetup(setup, callback))
	}

	useEffect(() => {
		if (
			sessionData.id !== false &&
			document.location.pathname.indexOf('/planner') !== -1 &&
			(
				Pages.planner.getUrl() === document.location.pathname ||
				Pages.planner.getUrl() + '/' === document.location.pathname ||
				Pages.planner.getUrl() + '/' === document.location.pathname + '/' ||
				Pages.planner.getUrl() === document.location.pathname + '/' ||
				Pages.plannerWithSession.getUrl(sessionData.id) !== document.location.pathname
			)
		) {
			history.push(Pages.plannerWithSession.getUrl(sessionData.id));
		}
	}, [sessionData.id, history]);

	return {
		item: sessionData.item,
		collection: sessionData.collection,
		delete: sessionData.delete,
		launchMethod,
		/***/
		getSession,
		setup: sessionData.setup,
		planner: sessionData.planner,
		updateSetup,
		getPixelValue: (value) => {
			return parseInt(value * sessionData.setup.ratio, 10)
		},
		getCmValue: (value) => {
			return value / sessionData.setup.ratio
		},
		session: sessionData.id,
		name: sessionData.name,
		loaded: sessionData.loaded,
		fetching: sessionData.fetching,
		defaultGroup: sessionData.defaultGroup
	};
};

export default useSession;
